import dayjs, {Dayjs} from "dayjs";
import i18next from "i18next";

export function duration(beginDate: Dayjs, endDate: Dayjs): string {
  const duration = endDate.diff(beginDate, "second");
  const days = Math.floor(duration / 86400);
  const hours = Math.floor((duration % 86400) / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  let durationString = "";
  if (days > 0) {
    durationString += `${i18next.t("duration.days", {count: days})}, `;
  }
  if (hours > 0) {
    durationString += `${i18next.t("duration.hours", {count: hours})}, `;
  }
  if (minutes > 0 || durationString === "") {
    durationString += i18next.t("duration.minutes", {count: minutes});
  }
  // remove potential trailing comma and space
  durationString = durationString.replace(/, $/, "");
  return durationString;
}

export function durationShort(beginDate: Dayjs, endDate: Dayjs): string {
  const seconds = endDate.diff(beginDate, "second");
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (days > 0) {
    return i18next.t("duration.days", {count: days});
  }
  if (hours > 0) {
    return i18next.t("duration.hours", {count: hours});
  }
  if (minutes > 0) {
    return i18next.t("duration.minutes", {count: minutes});
  }
  return `${seconds} s`;
}

export function formatDateTime(date: string | null, isUtc?: boolean): string {
  if (date === null || date === undefined) {
    return "N/A";
  }
  const dateToFormat = isUtc ? dayjs.utc(date) : dayjs(date);
  return dateToFormat.tz(dayjs.tz.guess()).format("DD/MM/YYYY HH:mm");
}

export function formatDate(date: string | null): string {
  if (date === null || date === undefined) {
    return "N/A";
  }
  return dayjs(date).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
}

export function formatDateShort(date: string | null): string {
  if (date === null || date === undefined) {
    return "N/A";
  }

  return dayjs(date).tz(dayjs.tz.guess()).format("D MMMM YYYY");
}

export function nbDaysUntilToday(date: string | null): string {
  if (date === null) {
    return "N/A";
  }

  const date1 = dayjs(date);
  const date2 = dayjs();
  const days = date2.diff(date1, "days");

  return days.toString();
}

export function utcHoursToLocalHours(dayTime: string): string {
  const [hours, minutes, seconds] = dayTime.split(":");
  const dateTimeLocal = dayjs()
    .utc()
    .set("hour", parseInt(hours))
    .set("minute", parseInt(minutes))
    .set("second", parseInt(seconds))
    .local();

  return dateTimeLocal.format("HH:mm:ss");
}

export function formatCountdown(date: string | null): string {
  if (date === null) {
    return "N/A";
  }

  const date1 = dayjs(date);
  const today = dayjs();
  if (date1.isSame(today, "day")) {
    return i18next.t("today");
  } else {
    const days = today.diff(date1, "days") + 1;
    return i18next.t("daysAgo", {count: days});
  }
}
